import React from 'react';
import PropTypes from 'prop-types';
import { useInView } from 'react-intersection-observer';
import HeroOverlapStyles from './HeroOverlap.styled';
import Card from '../../components/Card/Card';
import Picture from '../../components/Shared/Picture';

const HeroOverlap = ({
  children,
  position = 'full',
  background = '',
  mobileBackground = '',
  alt = '',
  backgroundColor = 'transparent',
  isAnimated = true,
}) => {
  const [ref, inView] = useInView({ triggerOnce: true, threshold: 0.25 });

  return (
    <HeroOverlapStyles
      position={position}
      ref={ref}
      backgroundColor={backgroundColor}
      className={`block-hero_overlap ${isAnimated ? 'isAnimated' : ''} ${
        inView ? 'active' : ''
      }`}
    >
      <Picture
        className='backdrop'
        src={`${background}?w=2560`}
        alt={alt}
        isResponsive={true}
        sources={[
          {
            media: '(min-width: 1440px)',
            params: '?w=2560',
            srcSet: background,
          },
          {
            media: '(min-width: 768px)',
            params: '?w=1440',
            srcSet: background,
          },
          {
            media: '(min-width: 425px)',
            params: '?w=768',
            srcSet: mobileBackground || background,
          },
          {
            media: '(max-width: 425px)',
            params: '?w=425',
            srcSet: mobileBackground || background,
          },
        ]}
      />

      <div className='inner'>
        <Card>{children}</Card>
      </div>
    </HeroOverlapStyles>
  );
};

HeroOverlap.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  position: PropTypes.oneOf(['full', 'left', 'right']),
  background: PropTypes.string,
  alt: PropTypes.string,
  isAnimated: PropTypes.bool,
};

export default HeroOverlap;
